module.exports = __webpack_public_path__ + "media/images/career_camp/2022/events/_technical_text-da8104ae4531bd835f032440dc1629af.svg";